import { Injectable } from '@angular/core';
import { SortDirection } from '@angular/material/sort';
import { ApiEndpointsService } from 'src/app/core/services/api-endpoints.service';
import { ApiHttpService } from 'src/app/core/services/api-http.service';

@Injectable({
  providedIn: 'root',
})
export class CounterpartsService {
  constructor(
    private apiEndpointsService: ApiEndpointsService,
    private apiHttpService: ApiHttpService
  ) {}

  getCounterparts(
    vehicleId: string,
    filters: any,
    page: number = 0,
    limit: number,
    sort: string,
    order: string
  ) {
    const updatedFilters = {
      ...filters,
      page: page + 1,
      limit,
      sort: sort,
      order: order,
    };

    const filteredParams: any = {};

    for (const [key, value] of Object.entries(updatedFilters)) {
      if (value !== undefined && value !== null && value !== '') {
        if (typeof value === 'object') {
          filteredParams[key] = JSON.stringify(value);
        } else {
          filteredParams[key] = value;
        }
      }
    }

    const url = this.apiEndpointsService.createUrlV2(
      `vehicles/${vehicleId}/counterparties`,
      false
    );
    return this.apiHttpService.get(url, { params: filteredParams });
  }
}
